import { render, staticRenderFns } from "./ListarTipoTrp.vue?vue&type=template&id=1d981056&"
import script from "./ListarTipoTrp.vue?vue&type=script&lang=js&"
export * from "./ListarTipoTrp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports